import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import ContainerFlex from '~/components/containerFlex';
import Loading from '~/components/loading';
import Pagination from '~/components/pagination';
import Select from '~/components/select';
import { TitleCategory } from '~/views/Consult/User/Detail/styles';

import TableList from '~/components/tableList';

import Container from '~/components/container';
import useApi, { ApiMethod } from '~/hooks/useApi';
import Endpoints from '~/services/endpoints';
import { IListColCampaing } from './model';

import Button from '~/components/button';
import * as St from './style';

const campaignTypes = [
  { value: 'Aumento de limite', id: 'AUMENTO_LIMITE' },
  { value: 'Comunicação', id: 'COMUNICACAO' },
  { value: 'Todos', id: 'TODOS' },
];

const campaignTypesCreate = [
  { value: 'Automática', id: 'AUTOMATICA' },
  { value: 'Manual', id: 'MANUAL' },
  { value: 'Todos', id: 'TODOS' },
];
export interface IResponseCampaing {
  limitePorPagina: number;
  paginaAtual: number;
  totalDePaginas: number;
  totalItens: number;
  pagina: {
    id: string | number;
    dataCriacao: string;
    dataValidade: string;
    nome: string;
    status: string;
    tipo: string;
    totalAtingidos: number;
    isManual: boolean;
  }[];
}

interface Form {
  totalAumento?: string;
  bronzeValue?: string | number;
  silverValue?: string | number;
  goldValue?: string | number;
  tipo?: string;
  status?: string;
  tipoCriacao?: string;
}

const LimitIncrease: React.FC = () => {
  const [list, setList] = useState([]);
  const [form, setForm] = useState<Form>({
    tipo: 'TODOS',
    status: 'TODOS',
    tipoCriacao: 'TODOS',
  });
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const history = useHistory();

  const GETSearchCampaign2 = useApi<IResponseCampaing>(
    Endpoints.fidelizacao.getSearchCampaign
      .replace('PARAM_LIMITE_PAGE', '10')
      .replace('PARAM_PAGE', currentPage.toString())
      .replace('PARAM_TIPO', form.tipo || 'TODOS') +
      (form.tipo === 'COMUNICACAO'
        ? form.tipoCriacao !== 'TODOS'
          ? `&isManual=${form.tipoCriacao === 'MANUAL' ? 'true' : 'false'}`
          : ''
        : ''),
    ApiMethod.GET,
  );
  const generateParams = () => {
    const params = {
      limitePorPagina: 10,
      pagina: currentPage.toString(),
      tipo: form.tipo || 'TODOS',
      status: form.status === 'TODOS' ? null : form.status,
    };
    if (form.tipo === 'COMUNICACAO' && form.tipoCriacao !== 'TODOS') {
      params['isManual'] = String(Boolean(form.tipoCriacao === 'MANUAL'));
    }
    return params;
  };
  const GETSearchCampaign = useApi<IResponseCampaing>({
    url: Endpoints.fidelizacao.getSearchCampaign,
    method: ApiMethod.GET,
    fetchOnMount: false,
  });

  const customerHeader = [
    {
      id: 1,
      value: 'Nome Campanha',
      maxChar: 15,
      textAlign: 'center',
    },
    {
      id: 2,
      value: 'Tipo',
      maxChar: 15,
      textAlign: 'center',
    },
    {
      id: 3,
      value: 'Tipo criação',
      maxChar: 15,
      textAlign: 'center',
    },
    {
      id: 4,
      value: 'Data campanha',
      maxChar: 15,
      textAlign: 'center',
    },
    {
      id: 5,
      value: 'Data validade',
      maxChar: 15,
      textAlign: 'center',
    },
    {
      id: 6,
      value: 'Total atingido',
      maxChar: 15,
      textAlign: 'center',
    },
    {
      id: 7,
      value: 'Status',
      maxChar: 10,
      textAlign: 'center',
    },
    {
      id: 8,
      value: 'Detalhes',
      maxChar: 10,
      textAlign: 'center',
    },
  ];

  const searchCampaign = async () => {
    const response = await GETSearchCampaign.callApi(generateParams());

    const { data } = response;

    const newList = [];
    let i = 0;

    if (response.status >= 200 && response.status < 300) {
      setTotalPages(data?.totalDePaginas);
      data?.pagina?.forEach((data) => {
        const item: IListColCampaing[] = [
          {
            type: 'id',
            value: data.id || i++,
            maxChar: 5,
          },
          { value: data.nome, maxChar: 15, textAlign: 'center' },
          {
            value: data.tipo.replace('_', ' '),
            maxChar: 15,
            textAlign: 'center',
          },
          {
            value: data.isManual ? 'Manual' : 'Automática',
            maxChar: 15,
            textAlign: 'center',
          },
          {
            value: data.dataCriacao
              ? moment(data.dataCriacao).format('DD/MM/YY')
              : '-',
            maxChar: 25,
            textAlign: 'center',
          },
          {
            value: data.dataValidade
              ? moment(data.dataValidade).format('DD/MM/YY')
              : '-',
            maxChar: 15,
            textAlign: 'center',
          },
          {
            value: `${data.totalAtingidos} cliente(s)`,
            maxChar: 10,
            textAlign: 'center',
          },
          {
            value: data.status,
            maxChar: 10,
            textAlign: 'center',
          },
          {
            maxChar: 10,
            item: data,
            textAlign: 'center',
            searchAction: goToDetailCampaign,
          },
        ];

        newList.push(item);
      });
    }

    setList(newList);
  };

  const goToDetailCampaign = (a: any, item: any) => {
    if (item.tipo === 'COMUNICACAO') {
      if (item.isManual) {
        history.push('/communication', {
          idCampaing: item.id,
          nameCampaing: item.nome,
          statusCampaing: item.status,
          isManual: item.isManual,
        });
      } else {
        history.push('/communication-preview', {
          idCampaing: item.id,
          nameCampaing: item.nome,
          statusCampaing: item.status,
        });
      }
    } else if (item.tipo === 'AUMENTO_LIMITE') {
      history.push('/lista-cliente-campanha', {
        idCampaing: item.id,
        nameCampaing: item.nome,
        statusCampaing: item.status,
      });
    }
  };

  const checkSuccess = () => {
    if (
      GETSearchCampaign.error ||
      GETSearchCampaign.status === 404 ||
      GETSearchCampaign.status === 500 ||
      list.length === 0
    ) {
      return true;
    }

    return false;
  };

  useEffect(() => {
    if (currentPage > 1) {
      searchCampaign();
    }
  }, [currentPage]);

  return (
    <>
      <Loading status={GETSearchCampaign.loading} />

      <Container>
        <St.BoxCard>
          <ContainerFlex padding={16} row space gap="32">
            <ContainerFlex gap="8" row>
              <ContainerFlex>
                <Select
                  value={form.tipo}
                  onChange={(e) => setForm((prev) => ({ ...prev, tipo: e }))}
                  label="Tipo de campanha"
                  options={campaignTypes}
                />
              </ContainerFlex>
              <ContainerFlex>
                <Select
                  value={form.status}
                  onChange={(e) => setForm((prev) => ({ ...prev, status: e }))}
                  label="Status"
                  options={[
                    { value: 'Todos', id: 'TODOS' },
                    { value: 'Preview', id: 'PREVIEW' },
                    { value: 'Cancelada', id: 'CANCELADA' },
                    { value: 'Finalizada', id: 'FINALIZADA' },
                  ]}
                />
              </ContainerFlex>
              {form.tipo === 'COMUNICACAO' && (
                <ContainerFlex>
                  <Select
                    value={form.tipoCriacao}
                    onChange={(e) =>
                      setForm((prev) => ({ ...prev, tipoCriacao: e }))
                    }
                    label="Tipo de criação"
                    options={campaignTypesCreate}
                  />
                </ContainerFlex>
              )}
            </ContainerFlex>
            <ContainerFlex gap="8" row end>
              <Button fitContent onClick={() => searchCampaign()}>
                Consultar
              </Button>
              <Button
                disabled={!form.tipo || form.tipo === 'TODOS'}
                onClick={() => {
                  const tipo = campaignTypes.find((e) => e.id === form.tipo)
                    ?.value;

                  if (tipo === 'Comunicação') {
                    history.push('/communication', { tipo });
                    return;
                  }
                  history.push('/criar-campanha', {
                    tipo,
                  });
                }}
                fitContent
              >
                Nova campanha
              </Button>
            </ContainerFlex>
          </ContainerFlex>
          <ContainerFlex row padding={16} wrap>
            <ContainerFlex>
              <ContainerFlex>
                <ContainerFlex padding={10}>
                  {list.length > 0 && (
                    <>
                      <TableList customerHeader={customerHeader} list={list} />

                      {totalPages > 1 && (
                        <ContainerFlex row horizontal center marginTop={20}>
                          <Pagination
                            totalPages={totalPages}
                            onCurrentPageChange={(page) => {
                              setCurrentPage(page);
                            }}
                          />
                        </ContainerFlex>
                      )}
                    </>
                  )}
                  {checkSuccess() && (
                    <ContainerFlex center marginTop={30}>
                      <TitleCategory>Nenhum resultado encontrado</TitleCategory>
                    </ContainerFlex>
                  )}
                </ContainerFlex>
              </ContainerFlex>
            </ContainerFlex>
          </ContainerFlex>
        </St.BoxCard>
      </Container>
    </>
  );
};

export default LimitIncrease;
